import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NadzornaPlocaService {
  constructor(private _http: HttpClient) {}

  nadzornaPloca(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'nadzornaploca_prikaz', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveLinije(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_sve_linije', a)
      .pipe(map((res: any) => res));
  }

  obracunPlanske(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'pocetni_obracun_planske', a)
      .pipe(map((res: any) => res));
  }

  kreirajRN(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'lansiraj_radninalog', a)
      .pipe(map((res: any) => res));
  }
}
